import request from "utils/request";
import { getStudentInfo } from "utils/userProfile";
import { mergeValidValues } from "utils/objectTools.js";
import DSBridge from "dsbridge";

// 提取共用的本地存储和客户端同步逻辑
const syncUserProfileToNative = (newData) => {
  const mergedData = mergeValidValues(getStudentInfo(), newData);

  try {
    localStorage.setItem("userInfo", JSON.stringify(mergedData));

    if (DSBridge.hasNativeMethod("auth.updateUserProfile")) {
      const accessToken = localStorage.getItem("access_token");
      if (accessToken) {
        // 为客户端提供两个 token 字段
        const payload = {
          ...mergedData,
          token: accessToken,
          refresh_token: localStorage.getItem("refresh_token") || "",
        };
        DSBridge.call("auth.updateUserProfile", JSON.stringify(payload));
      }
    }
  } catch (e) {
    console.error("syncUserProfileToNative error:", e);
  }
};

export async function getUserInfo() {
  const userInfo = await request.get("/profile/getUserInfo.php", "nocache");
  if (userInfo?.status === true) {
    syncUserProfileToNative(userInfo.data);
  }
  return userInfo;
}

export async function updateUserProfile(data) {
  return request.post("/profile/updateUserProfile.php", data, "nocache");
}

export async function getUserProfile() {
  const profileRes = await request.get(
    "/profile/getUserProfile.php",
    "nocache",
  );
  if (profileRes?.code === 200) {
    syncUserProfileToNative(profileRes.data);
  }
  return profileRes;
}

export async function getUserCourse() {
  return request.get("/profile/getUserCourse.php", "nocache");
}

export function deleteUserController() {
  return request.delete("/profile/deleteUserController.php", "nocache");
}
